import {
	Button,
	FormControl,
	FormLabel,
	Grid,
	makeStyles,
	MenuItem,
	RadioGroup,
	Radio,
	FormControlLabel,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import addLeads from '../../../api/SendEmails/addLeads.api';
import deleteLeadIdentification from '../../../api/Leads/deleteLeadIdentification.api';
import styles from './LeadsForm.module.scss';
import { connect } from 'react-redux';
import { validateEmail } from '../../../utils/validateEmail';
import _ from 'lodash';
import Confirmation from '../../confirmation/ConfirmationComponent';
import {
	closeConfirmation,
	setConfirmation,
} from '../../../redux/confirmations/actions';
import { closeModal } from '../../../redux/modals/action';
import { setAlert } from '../../../redux/alerts/action';
import {
	validatePhoneNumber,
	reformatPhoneString,
} from '../../../utils/validatePhoneNumber';
import { inputEmptyChecker } from '../../../utils/inputEmptyChecker';
import { checkForValueInJson } from '../../../utils/checkForValueInJson';
import CustomTextField from '../../layout/customTextField/CustomTextField';
import CustomSlider from '../../layout/customSlider/CustomSlider';

const priceMarks = [
	{
		value: 0,
		label: '$0',
	},
	{
		value: 2500000,
		label: '$2.5M',
	},
	{
		value: 5000000,
		label: '$5M+',
	},
];
const sqftMarks = [
	{
		value: 0,
		label: '0sqft',
	},
	{
		value: 9000,
		label: 'Unlimited',
	},
];
const LeadsForm = ({
	// parent props
	show,
	source,
	leadById,
	editKey,
	handleCloseLeads,
	// redux
	user,
	salesAgents,
	confirmation,
	closeConfirmation,
	setConfirmation,
	closeModal,
	setAlert,
}) => {
	const useStyles = makeStyles(() => ({
		root: {
			backgroundColor: '#fff',
			width: '100%',
			minWidth: '28em',
			// maxWidth: '50%',
			// boxSizing: 'border-box',
		},
	}));

	const classes = useStyles();
	const [formData, setFormData] = useState({});
	const [error, setError] = useState();
	const [params, setParams] = useState({
		sqft: [0, 9000],
		price: [0, 5000000],
	});
	const {
		leadToSalesAgent,
		clientFName,
		clientLName,
		clientEmail,
		clientPhoneNumber,
		city,
		postalCode,
		reference,
		buyerType,
		desiredSize,
		desiredPrice,
		mortgageQualification,
		comments,
	} = formData;
	useEffect(() => {
		if (leadById && editKey) {
			setFormData(leadById);
		} else {
			setFormData({
				leadToSalesAgent: user.uid,
				clientFName: '',
				clientLName: '',
				clientEmail: '',
				clientPhoneNumber: '',
				city: '',
				postalCode: '',
				reference: '',
				buyerType: '',
				desiredSize: '',
				desiredPrice: '',
				mortgageQualification: '',
				realStateAgent: 'yes',
				comments: '',
				createTimestamp: Date.now(),
			});
		}
	}, [leadById, editKey, salesAgents, show]);

	const onChange = (e) => {
		let name = e.target.name;
		let value;
		if (name === 'clientEmail') {
			if (
				validateEmail(e.target.value) !== true ||
				inputEmptyChecker(e.target.value)
			) {
				setError({ ...error, [name]: true });
			} else {
				error && delete error[e?.target?.name];
			}
		} else if (name === 'clientPhoneNumber') {
			if (
				validatePhoneNumber(e.target.value) !== true ||
				inputEmptyChecker(e.target.value)
			) {
				setError({ ...error, [name]: true });
			} else {
				value = reformatPhoneString(e.target.value);
				error && delete error[name];
			}
		}

		if (
			inputEmptyChecker(e.target.value) &&
			(e.target.name === 'clientFName' ||
				e.target.name === 'clientLName' ||
				e.target.name === 'city' ||
				e.target.name === 'postalCode')
		) {
			setError({ ...error, [name]: true });
		} else {
			error && delete error[name];
		}

		setFormData({
			...formData,
			[name]: value ? value : e.target.value,
		});
	};

	const handleRegisterLead = (e) => {
		e.preventDefault();
		let forms = formData;
		if (!_.isEqual(params.sqft, [0, 9000])) {
			let sortedArr = _.sortBy(params.sqft);
			forms['desiredSize'] = {
				minVal: sortedArr[0],
				maxVal: sortedArr[1],
			};
		}
		if (!_.isEqual(params.price, [0, 5000000])) {
			let sortedArr = _.sortBy(params.price);
			forms['desiredPrice'] = {
				minVal: sortedArr[0],
				maxVal: sortedArr[1],
			};
		}
		if (
			_.isEmpty(error) === true ||
			_.isEmpty(error) === true ||
			checkForValueInJson(error, true) !== true
		) {
			if (editKey !== '' && editKey !== undefined && editKey !== null) {
				setConfirmation('editLeads');
			} else {
				addLeads(forms, editKey, (alertType, message) => {
					setAlert(alertType, message);
				});
				closeModal('addLeads');

				setFormData({
					leadToSalesAgent: user.uid,
					clientFName: '',
					clientLName: '',
					clientEmail: '',
					clientPhoneNumber: '',
					city: '',
					postalCode: '',
					reference: '',
					buyerType: '',
					desiredSize: '',
					desiredPrice: '',
					mortgageQualification: '',
					realStateAgent: 'yes',
					comments: '',
					createTimestamp: Date.now(),
				});
			}
		} else {
			setAlert('error', 'Form is invalid.');
		}
	};

	const handleCloseConfirmation = () => {
		closeConfirmation('editLeads');
	};

	const handleSaveEditLead = () => {
		let verificationStatus =
			leadById?.identification?.verification?.status ===
				'manually_verified' ||
			leadById?.identification?.verification?.status === 'verified';
		let isNameChanged =
			verificationStatus &&
			(leadById?.clientFName !== formData.clientFName ||
				leadById?.clientLName !== formData.clientLName);

		addLeads(formData, editKey, (alertType, message) => {
			setAlert(alertType, message);
		});

		if (isNameChanged) deleteLeadIdentification(editKey);
		if (handleCloseLeads) {
			handleCloseLeads();
		}

		closeConfirmation('editLeads');
		closeModal('addLeads');
	};

	var buttonList = [
		{
			name: 'Discard',
			action: () => {
				handleCloseConfirmation();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Save lead',
			action: () => {
				handleSaveEditLead();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
	];

	return (
		<form
			onSubmit={handleRegisterLead}
			className={styles.leads_form}
			method='POST'
		>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6}>
					<div className={styles.item}>
						<CustomTextField
							formLabel='First Name'
							name={'clientFName'}
							value={clientFName ?? ''}
							onChange={(e) => onChange(e)}
							type={'string'}
							InputLabelProps={{
								shrink: true,
							}}
							required
							error={
								error && error['clientFName'] === true
									? true
									: false
							}
							errorMessage={'This field is required'}
							placeholder='First Name'
							autoComplete='off'
						/>
					</div>
					<div className={styles.item}>
						<CustomTextField
							formLabel='Last Name'
							name={'clientLName'}
							value={clientLName ?? ''}
							onChange={(e) => onChange(e)}
							type={'string'}
							InputLabelProps={{
								shrink: true,
							}}
							required
							error={
								error && error['clientLName'] === true
									? true
									: false
							}
							errorMessage={'This field is required'}
							placeholder='Last Name'
							autoComplete='off'
						/>
					</div>
					<div className={styles.item}>
						<CustomTextField
							formLabel='Client Email'
							name={'clientEmail'}
							value={clientEmail?.toLowerCase() ?? ''}
							onChange={(e) => onChange(e)}
							type={'string'}
							InputLabelProps={{
								shrink: true,
							}}
							required
							error={
								error && error['clientEmail'] === true
									? true
									: false
							}
							errorMessage={'This field is required or invalid.'}
							placeholder='Client Email'
							autoComplete='off'
						/>
					</div>
					<div className={styles.item}>
						<CustomTextField
							formLabel='Client Phone Number'
							name={'clientPhoneNumber'}
							value={clientPhoneNumber ?? ''}
							onChange={(e) => onChange(e)}
							type={'string'}
							InputLabelProps={{
								shrink: true,
							}}
							required
							error={
								error && error['clientPhoneNumber'] === true
									? true
									: false
							}
							errorMessage={'This field is required or invalid.'}
							placeholder='Client Phone Number'
							autoComplete='off'
						/>
					</div>
					<div className={styles.item}>
						<CustomTextField
							formLabel='City'
							name={'city'}
							value={city ?? ''}
							onChange={(e) => onChange(e)}
							type={'string'}
							InputLabelProps={{
								shrink: true,
							}}
							required
							error={
								error && error['city'] === true ? true : false
							}
							errorMessage={'This field is required.'}
							placeholder='City'
							autoComplete='off'
						/>
					</div>
					<div className={styles.item}>
						<CustomTextField
							formLabel='Postal Code'
							name={'postalCode'}
							value={postalCode?.toUpperCase() ?? ''}
							onChange={(e) => onChange(e)}
							type={'string'}
							InputLabelProps={{
								shrink: true,
							}}
							required
							error={
								error && error['postalCode'] === true
									? true
									: false
							}
							errorMessage={'This field is required.'}
							placeholder='Postal Code'
							autoComplete='off'
						/>
					</div>
					<div className={styles.item}>
						<CustomTextField
							formLabel={'How did you hear about us?'}
							name='reference'
							value={reference ?? ''}
							required={false}
							onChange={(e) => onChange(e)}
							type={'select'}
							placeholder={'How did you hear about us?'}
							select
							SelectProps={
								reference === ''
									? {
											style: {
												backgroundColor: 'white',
												color: '#979797',
												'&.MuiSelectSelect:focus': {
													backgroundColor: 'white',
												},
											},
											MenuProps: {
												menulistprops: {
													disablePadding: true,
												},
											},
											displayEmpty: true,
											renderValue: () =>
												'How did you hear about us?',
									  }
									: {
											style: {
												backgroundColor: 'white',
												'&.MuiSelectSelect:focus': {
													backgroundColor: 'white',
												},
											},
											MenuProps: {
												menulistprops: {
													disablePadding: true,
												},
											},
									  }
							}
							menulistprops={{
								disablePadding: true,
							}}
							autoComplete='off'
						>
							{/* <MenuItem disabled value=''>
								How did you hear about us?
							</MenuItem> */}
							<MenuItem value='Signage'>Signage</MenuItem>
							<MenuItem value='Website'>Website</MenuItem>
							<MenuItem value='Agent'>Agent</MenuItem>
							<MenuItem value='Friend / Family'>
								Friend / Family
							</MenuItem>
							<MenuItem value='Social Media'>
								Social Media
							</MenuItem>
							<MenuItem value='Other'>Other</MenuItem>
						</CustomTextField>
					</div>
					<div className={styles.item}>
						<CustomTextField
							formLabel={'What type of buyer are you?'}
							name='buyerType'
							value={buyerType ?? ''}
							required={false}
							onChange={(e) => onChange(e)}
							type={'select'}
							placeholder={'What type of buyer are you?'}
							select
							SelectProps={
								buyerType === ''
									? {
											style: {
												backgroundColor: 'white',
												color: '#979797',
												'&.MuiSelectSelect:focus': {
													backgroundColor: 'white',
												},
											},
											MenuProps: {
												menulistprops: {
													disablePadding: true,
												},
											},
											displayEmpty: true,
											renderValue: () =>
												'What type of buyer are you?',
									  }
									: {
											style: {
												backgroundColor: 'white',
												'&.MuiSelectSelect:focus': {
													backgroundColor: 'white',
												},
											},
											MenuProps: {
												menulistprops: {
													disablePadding: true,
												},
											},
									  }
							}
							menulistprops={{
								disablePadding: true,
							}}
							autoComplete='off'
						>
							<MenuItem value='First time buyer'>
								First time buyer
							</MenuItem>
							<MenuItem value='Move up buyer'>
								Move up buyer
							</MenuItem>
							<MenuItem value='Downsizing'>Downsizing</MenuItem>
							<MenuItem value='Investor'>Investor</MenuItem>
						</CustomTextField>
					</div>
				</Grid>
				<Grid item xs={12} sm={6}>
					<div className={styles.item}>
						<CustomTextField
							formLabel={
								'Have you been pre-qualified for a mortgage?'
							}
							name='mortgageQualification'
							value={mortgageQualification ?? ''}
							required={false}
							onChange={(e) => onChange(e)}
							type={'select'}
							placeholder={
								'Have you been pre-qualified for a mortgage?'
							}
							select
							SelectProps={
								mortgageQualification === ''
									? {
											style: {
												backgroundColor: 'white',
												color: '#979797',
												'&.MuiSelectSelect:focus': {
													backgroundColor: 'white',
												},
											},
											MenuProps: {
												menulistprops: {
													disablePadding: true,
												},
											},
											displayEmpty: true,
											renderValue: () =>
												'Pre-qualified for a mortgage?',
									  }
									: {
											style: {
												backgroundColor: 'white',
												'&.MuiSelectSelect:focus': {
													backgroundColor: 'white',
												},
											},
											MenuProps: {
												menulistprops: {
													disablePadding: true,
												},
											},
									  }
							}
							menulistprops={{
								disablePadding: true,
							}}
							autoComplete='off'
						>
							<MenuItem value='yes'>Yes</MenuItem>
							<MenuItem value='no'>No</MenuItem>
						</CustomTextField>
					</div>
					<div className={styles.item}>
						<div className={styles.sliderWrapper}>
							<FormLabel className={classes.inputLabel}>
								Desired Size
							</FormLabel>

							<CustomSlider
								// formLabel='Sqft'
								defaultMin={
									Number(leadById?.desiredSize?.minVal) ||
									params['sqft'][0]
								}
								defaultMax={
									Number(leadById?.desiredSize?.maxVal) ||
									params['sqft'][1]
								}
								rangeMin={0}
								rangeMax={9000}
								name='sqft'
								params={params}
								setParams={setParams}
								suffix={'sqft'}
								customLabel={{ max: 'Unlimited' }}
								marks={sqftMarks}
							/>
						</div>
					</div>

					<div className={styles.item}>
						<div className={styles.sliderWrapper}>
							<FormLabel className={classes.inputLabel}>
								Desired price
							</FormLabel>
							<CustomSlider
								defaultMin={
									Number(leadById?.desiredPrice?.minVal) ||
									params['price'][0]
								}
								defaultMax={
									Number(leadById?.desiredPrice?.maxVal) ||
									params['price'][1]
								}
								rangeMin={0}
								rangeMax={5000000}
								name='price'
								params={params}
								setParams={setParams}
								prefix={'$'}
								customLabel={{ max: '5M+' }}
								marks={priceMarks}
							/>
						</div>
					</div>

					<div className={styles.item}>
						<div className={styles.sliderWrapper}>
							<FormControl fullWidth component='fieldset'>
								<FormLabel
									className={styles.label}
									component='legend'
								>
									Are you a real-state agent?
								</FormLabel>
								<RadioGroup
									row
									aria-labelledby='realstate-agent-radio-btn'
									name={'realStateAgent'}
									value={formData.realStateAgent ?? ''}
									onChange={(e) => onChange(e)}
								>
									<FormControlLabel
										value='yes'
										control={<Radio color='primary' />}
										label='Yes'
									/>
									<FormControlLabel
										value='no'
										control={<Radio color='primary' />}
										label='No'
									/>
								</RadioGroup>
							</FormControl>
						</div>
					</div>

					<div className={styles.item}>
						<CustomTextField
							formLabel='Comments'
							placeholder='Write your comments here'
							onChange={(e) => onChange(e)}
							multiline={true}
							charLimit={300}
							charLeft={_.size(comments)}
							name='comments'
							value={comments ?? ''}
							autoComplete='off'
						/>
					</div>
				</Grid>
			</Grid>

			<Confirmation
				open={confirmation?.editLeads}
				handleClose={handleCloseConfirmation}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={buttonList}
			/>

			<Button
				className={styles.register_btn}
				variant='contained'
				type='submit'
			>
				{editKey ? 'Save Edit' : 'Add'}
			</Button>
		</form>
	);
};

const mapStateToProps = (state) => ({
	user: state.signIn,
	salesAgents: state.leads.salesAgents,
	confirmation: state.confirmation,
});

export default connect(mapStateToProps, {
	closeConfirmation,
	setConfirmation,
	closeModal,
	setAlert,
})(LeadsForm);
